// extracted by mini-css-extract-plugin
module.exports = {"links":"style_links__rFMYA","top":"style_top__7YcQI","list":"style_list__BmQpQ","element":"style_element__H3W8w"};